/* eslint-disable no-new-func, no-plusplus */
import { PureComponent } from 'react'
import PropTypes from 'prop-types'

import {
  Container, VkWrapper, IframeWrapper
} from './styles'

const vkWidget = /VK\.Widgets\.(Playlist|Post)\("(.+)", .+\);/i
const youTubeLink = /youtube\.com\/watch\?v=([^&]+)/i
const youTubeShortLink = /youtu\.be\/(.+)/i
const videoEmbedReg = /(youtube\.com\/embed\/|vk\.com\/video_ext\.php)/i

export default class EmbedContent extends PureComponent {
  static propTypes = {
    content: PropTypes.string.isRequired,
    className: PropTypes.string,
    withMargin: PropTypes.bool,
    rounded: PropTypes.bool
  }

  static getDerivedStateFromProps(props) {
    const { content } = props
    if (!content) {
      return null
    }

    const vkMatched = content.match(vkWidget)
    if (vkMatched) {
      const vkInitCode = vkMatched[0]
      const vkContainerId = vkMatched[2]

      return {
        vkContainerId,
        vkInitCode
      }
    }

    const videoEmbedMatched = content.match(videoEmbedReg)
    if (content.match(/<iframe/i)) {
      return { hasIframe: true, videoEmbed: videoEmbedMatched }
    }

    const youTubeLinkMatched = content.match(youTubeLink) || content.match(youTubeShortLink)
    if (youTubeLinkMatched) {
      return { youTubeId: youTubeLinkMatched[1] }
    }

    return null
  }

  static defaultProps = {
    className: null,
    withMargin: false,
    rounded: false
  }

  state = {
    vkContainerId: null,
    vkInitCode: null,
    hasIframe: false,
    youTubeId: null,
    videoEmbed: false
  }

  constructor() {
    super()
    this.vkTries = 0
    this.initVk.bind(this)
  }

  componentDidMount() {
    const { vkInitCode } = this.state
    if (vkInitCode) {
      this.initVk()
    }
  }

  initVk = () => {
    if (this.vkTries++ > 4) return

    if (typeof VK === 'undefined') {
      setTimeout(this.initVk, 300)
      return
    }

    const { vkInitCode } = this.state
    new Function(vkInitCode)()
  }

  render() {
    const {
      className, content, withMargin, rounded
    } = this.props
    const {
      vkContainerId, hasIframe, youTubeId, videoEmbed
    } = this.state

    if (!content) {
      return null
    }

    return (
      <Container className={className} withMargin={withMargin} rounded={rounded}>
        {vkContainerId && <VkWrapper id={vkContainerId} />}
        {hasIframe && <IframeWrapper youTube={videoEmbed} dangerouslySetInnerHTML={{ __html: content }} />}
        {youTubeId && (
        <IframeWrapper youTube>
          <iframe
            width="560"
            height="315"
            src={`https://www.youtube.com/embed/${youTubeId}`}
            frameBorder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            title="youtube video"
            allowFullScreen
          />
        </IframeWrapper>
        )}
      </Container>
    )
  }
}
